import { toFixedDecimal } from "./utils";
export default class P_PIM_PDO {
    constructor() {
        this.BSUModelVerNum = '0';
        this.BedsideControl = '0';
        this.digital5V = '0';
        this.digital3V = '0';
        this.X3VCurrent = '0';
        this.X5VCurrent = '0';
        this.ledCurrent = '0';
        this.SUI = '0';
    }
    static fromJson(json) {
        if (json) {
            let p_PIM_PDO = new P_PIM_PDO();
            if (json.digital5V) {
                p_PIM_PDO.digital5V = toFixedDecimal(json.digital5V);
            }
            if (json.digital3V) {
                p_PIM_PDO.digital3V = toFixedDecimal(json.digital3V);
            }
            if (json.X3VCurrent) {
                p_PIM_PDO.X3VCurrent = toFixedDecimal(json.X3VCurrent);
            }
            if (json.X5VCurrent) {
                p_PIM_PDO.X5VCurrent = toFixedDecimal(json.X5VCurrent);
            }
            if (json.ledCurrent) {
                p_PIM_PDO.ledCurrent = toFixedDecimal(json.ledCurrent);
            }
            if (json.SUI) {
                p_PIM_PDO.SUI = toFixedDecimal(json.SUI);
            }
            return p_PIM_PDO;
        }
        return null;
    }
}
//# sourceMappingURL=P_PIM_PDO.js.map